import React from 'react';
import PropTypes from 'prop-types';
import { IMAGE_CONSTANTS } from '../constants/ImageConstans';
import { TEXT_LABELS } from '../constants/TextLabelConstants';
import RapFireQuestionPoints, {
  mapGameStateToPointStates,
} from './rap_fire/RapFireQuestionPoints';
import './LobbyJoinedPlayerRow.css';

/**
 * Figma 18011:21589 / 18423:3743 — pastel glass joined-player row
 * Lobby: "Joined" badge. RapFire live: QA progress icons from gameState.
 */
const LobbyJoinedPlayerRow = ({ username, avatar, gameState, className = '' }) => {
  const showQuestionPoints = Array.isArray(gameState) && gameState.length > 0;
  const pointStates = showQuestionPoints ? mapGameStateToPointStates(gameState) : [];

  return (
    <div
      className={`lobby-player-row${className ? ` ${className}` : ''}`}
      data-node-id={showQuestionPoints ? '18423:3743' : undefined}
    >
      <div className="lobby-player-row__left">
        <img
          className="lobby-player-row__avatar"
          src={avatar || IMAGE_CONSTANTS.V2_IMAGE_PLACEHOLDER}
          alt={username || 'Player'}
        />
        <span className="lobby-player-row__name">{username || 'Player'}</span>
      </div>
      {showQuestionPoints ? (
        <RapFireQuestionPoints states={pointStates} />
      ) : (
        <span className="lobby-player-row__joined">
          {TEXT_LABELS.RAP_HOUSIE_ROOM_GAME_CODE_SHARE_JOINED_STATUS_JOIN}
        </span>
      )}
    </div>
  );
};

LobbyJoinedPlayerRow.propTypes = {
  username: PropTypes.string,
  avatar: PropTypes.string,
  gameState: PropTypes.arrayOf(PropTypes.string),
  className: PropTypes.string,
};

export default LobbyJoinedPlayerRow;
